import React, { memo } from "react";
import Box from "@mui/material/Box";
import { ReactRouterLink } from "../Link";
import sxStyles from "./Logo.style";
const Logo = ({ to = "/", linkComponent: LinkComponent = ReactRouterLink, }) => (React.createElement(Box, { sx: [
        {
            display: "flex",
            alignItems: "center",
        },
        (theme) => sxStyles(theme).root,
    ] },
    React.createElement(Box, { component: LinkComponent, to: to, sx: (theme) => sxStyles(theme).logoLink, "aria-label": "Logo" },
        React.createElement(Box, { component: "svg", sx: (theme) => sxStyles(theme).logo, viewBox: "0 0 49 49" },
            React.createElement("g", { fill: "currentColor", fillRule: "nonzero" },
                React.createElement("path", { d: "M15.35 34.145a15.72 15.72 0 018.84-28.73 15.93 15.93 0 013.48.39l2.16-5C19.675-2.079 8.953 2.996 4.747 12.68.541 22.362 4.15 33.662 13.19 39.115l2.16-4.97z" }),
                React.createElement("path", { d: "M33.77 21.145a9.58 9.58 0 11-19.16 0 9.58 9.58 0 0119.16 0" }),
                React.createElement("path", { d: "M24.58 42.215a21.07 21.07 0 0010.61-39l-2.16 5a15.72 15.72 0 01-8.84 28.73 15.34 15.34 0 01-3.48-.4l-5.24 12h6.37l2.74-6.33z" }))))));
export default memo(Logo);
//# sourceMappingURL=Logo.js.map